import {
  FormControl,
  Select as MuiSelect,
  type SelectProps as MuiSelectProps,
  Stack,
} from '@mui/material';
import { useId } from 'react';

import Label from '../Label';

type Props = MuiSelectProps & {
  label?: string;
  tooltipText?: string;
};

export default function Select({ label, tooltipText, ...props }: Props) {
  if (label) {
    return (
      <Stack
        sx={{
          gap: 0.5,
          alignItems: 'flex-start',
        }}
      >
        {label && <Label tooltipText={tooltipText}>{label}</Label>}
        <BaseSelect {...props} />
      </Stack>
    );
  }

  return <BaseSelect {...props} />;
}

function BaseSelect({ sx, ...props }: any) {
  const id = useId();
  return (
    <FormControl
      variant="filled"
      sx={{ ...sx, minWidth: 120 }}
    >
      <MuiSelect
        id={id}
        {...props}
      />
    </FormControl>
  );
}
